import { isNaN } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedBudget } from '../../../state/BudgetList/budgetListSlice';
import { ActualTimes } from '../../../utils/constants/budget';
import { Option, TimeFrame } from '../../../utils/customTypes';
import useBudgetLineItemCalculations from './useBudgetLineItemCalculations';

export const useLineItemTotalCalculations = (activeTimeframe: Option) => {
  const { allLineItems } = useBudgetLineItemCalculations();
  let [sumOfAmounts, setSumOfAmounts] = useState(0);
  let [sumOfActuals, setSumOfActuals] = useState(0);

  const selectedBudget = useSelector(getSelectedBudget);

  useEffect(() => {
    let actualSum = 0;
    let amountSum = 0;

    const fiscalMonthStart = selectedBudget
      ? new Date(selectedBudget.fiscalPeriodStart).getTime()
      : 0;

    if (
      !isNaN(parseFloat(activeTimeframe?.value)) &&
      isFinite(activeTimeframe?.value)
    ) {
      const index = parseFloat(activeTimeframe?.value);

      if (selectedBudget?.timeFrame === TimeFrame.MONTHLY) {
        actualSum = allLineItems.reduce((sum, lineItem) => {
          const amount = lineItem.rawActuals
            ? lineItem.rawActuals[(fiscalMonthStart + index) % 12]
            : 0;
          return sum + (amount ?? 0);
        }, 0);

        amountSum = allLineItems.reduce((sum, lineItem) => {
          const amount = lineItem.rawAmounts
            ? lineItem.rawAmounts[(fiscalMonthStart + index) % 12]
            : 0;
          return sum + amount;
        }, 0);
      } else {
        actualSum = allLineItems.reduce((sum, lineItem) => {
          const amount = lineItem.rawActuals ? lineItem.rawActuals[index] : 0;
          return sum + amount;
        }, 0);

        amountSum = allLineItems.reduce((sum, lineItem) => {
          const amount = lineItem.rawAmounts ? lineItem.rawAmounts[index] : 0;
          return sum + amount;
        }, 0);
      }
    } else if (activeTimeframe.value === ActualTimes.FISCAL_CURRENT) {
      amountSum = allLineItems.reduce((total: number, item) => {
        const rawAmountsSum = item.rawAmounts?.reduce(
          (sum, amount) => sum + amount,
          0
        );
        return total + (rawAmountsSum ?? 0);
      }, 0);

      actualSum = allLineItems.reduce((total: number, item) => {
        const rawActualsSum = item.rawActuals?.reduce(
          (sum, amount) => sum + amount,
          0
        );
        return total + (rawActualsSum ?? 0);
      }, 0);
    }

    setSumOfActuals(actualSum);
    setSumOfAmounts(amountSum);
  }, [activeTimeframe, allLineItems, selectedBudget]);

  return { sumOfActuals, sumOfAmounts };
};
